import { sprintf } from "sprintf-js";
import { useSite } from "./use-site";
import { useSiteOwnerName } from "./use-site-owner-name";
export var useSiteFooterContent = function () {
  var _a;
  var site = useSite();
  var ownerName = useSiteOwnerName();
  if ((_a = site === null || site === void 0 ? void 0 : site.footerContent) === null || _a === void 0 ? void 0 : _a.text) {
    return site.footerContent.text;
  }
  // default content if no footer content is set
  return sprintf("\u00A9 {year}%s. All Rights Reserved", ownerName && " ".concat(ownerName));
};